export class FirebaseFile {
  fileExtension!: string;
  fileName!: string;
  storageBucket!: string;
  storageId!: string;
}
